import { createContext, useContext, useState, useEffect } from 'react'
import { useTelegram } from './TelegramContext'

const CartContext = createContext({})

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([])
  const { hapticFeedback } = useTelegram()

  // Загружаем корзину из localStorage при монтировании
  useEffect(() => {
    const savedCart = localStorage.getItem('cart')
    if (savedCart) {
      try {
        setCart(JSON.parse(savedCart))
      } catch (e) {
        console.error('Ошибка загрузки корзины:', e)
      }
    }
  }, [])

  // Сохраняем корзину в localStorage при изменении
  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart))
  }, [cart])

  const addToCart = (product, quantity = 1, size = null, color = null) => {
    setCart(prevCart => {
      // Проверяем, есть ли такой товар с такими параметрами
      const existingItemIndex = prevCart.findIndex(
        item => 
          item.product_id === product.id &&
          item.size === size &&
          item.color === color
      )

      if (existingItemIndex > -1) {
        // Увеличиваем количество
        const newCart = [...prevCart]
        newCart[existingItemIndex].quantity += quantity
        return newCart
      } else {
        // Добавляем новый товар
        return [...prevCart, {
          product_id: product.id,
          product: product,
          quantity,
          size,
          color
        }]
      }
    })
    
    hapticFeedback?.('success')
  }

  const removeFromCart = (productId, size = null, color = null) => {
    setCart(prevCart => prevCart.filter(
      item => !(
        item.product_id === productId &&
        item.size === size &&
        item.color === color
      )
    ))
    
    hapticFeedback?.('light')
  }

  const updateQuantity = (productId, size, color, newQuantity) => {
    if (newQuantity <= 0) {
      removeFromCart(productId, size, color)
      return
    }

    setCart(prevCart => prevCart.map(item => {
      if (
        item.product_id === productId &&
        item.size === size &&
        item.color === color
      ) {
        return { ...item, quantity: newQuantity }
      }
      return item
    }))
  }

  const clearCart = () => {
    setCart([])
    hapticFeedback?.('light')
  }

  const getCartTotal = () => {
    return cart.reduce((total, item) => total + (item.product.price * item.quantity), 0)
  }

  const getCartItemsCount = () => {
    return cart.reduce((count, item) => count + item.quantity, 0)
  }

  const value = {
    cart,
    addToCart,
    removeFromCart,
    updateQuantity,
    clearCart,
    getCartTotal,
    getCartItemsCount,
    hapticFeedback
  }

  return (
    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  )
}

export const useCart = () => useContext(CartContext)











